import UIFlex from 'UIComponents/layout/UIFlex';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import PublicSearch from '../../publicSearch/components/PublicSearch';
import PublicPageNavDropdown from './PublicPageNavDropdown';
import PublicPageNavLink from './PublicPageNavLink';
import PublicPageAuthButtons from './PublicPageAuthButtons';
import PublicPageThemeToggle from './PublicPageThemeToggle';
import PublicLanguageDropdown from '../../publicLanguage/components/PublicLanguageDropdown';
import usageTracker from '../../../utils/usageTracker';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileNavMenu = styled.nav.withConfig({
  displayName: "PublicPageMobileNavMenu__MobileNavMenu",
  componentId: "sc-1r8gogb-0"
})(["position:fixed;left:0;top:", ";width:100%;background-color:", ";padding:12px;height:calc(100vh - ", ");visibility:hidden;opacity:0;.menu-rows{padding:0;list-style:none;li{margin-bottom:16px;}}&[aria-hidden='false']{visibility:visible;opacity:1;}"], theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT, theme.colors.OLAF, theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT);
const PublicPageMobileNavMenu = () => {
  const {
    isShowing,
    toggle
  } = useToggle(false);
  const handleTrackNavItemClick = e => {
    usageTracker.track('navInteraction', {
      action: 'nav-item-click',
      href: e.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      "aria-controls": "mobileNavMenu",
      "aria-expanded": isShowing,
      onClick: () => toggle(),
      use: "transparent",
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: theme.colors.OBSIDIAN,
        name: isShowing ? 'remove' : 'listView',
        size: 30,
        style: {
          position: 'relative',
          top: 3,
          left: -1
        }
      })
    }), /*#__PURE__*/_jsx(MobileNavMenu, {
      "aria-hidden": !isShowing,
      id: "mobileNavMenu",
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsxs("ul", {
          className: "menu-rows",
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(PublicSearch, {})
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(PublicPageNavDropdown, {})
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(PublicPageNavLink, {
              href: getProxyUrl('what-is-hubspot-academy'),
              onClick: handleTrackNavItemClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.publicNav.about"
              })
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(PublicPageAuthButtons, {})
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsxs(UIFlex, {
              children: [/*#__PURE__*/_jsx(PublicPageThemeToggle, {}), /*#__PURE__*/_jsx(PublicLanguageDropdown, {})]
            })
          })]
        })
      })
    })]
  });
};
export default PublicPageMobileNavMenu;